import { Tooltip } from "antd";
import { palette } from "../theme/tokens";
import { useColorMode } from "../theme/ThemeProvider";
import { useCompose } from "./ComposeContext";

const COLORS = ["#5B6CFF", "#22C55E", "#FF9F43", "#EF4444", "#A855F7", "#06B6D4", "#F59E0B"];

function colorFor(seed: string): string {
  let h = 0;
  for (let i = 0; i < seed.length; i += 1) h = (h * 31 + seed.charCodeAt(i)) >>> 0;
  return COLORS[h % COLORS.length] ?? COLORS[0]!;
}

function initialsOf(name: string | null, email: string): string {
  const src = name?.trim() || email;
  const parts = src.split(/[\s@.+_-]+/).filter(Boolean);
  if (parts.length >= 2) {
    return (parts[0]![0] ?? "").toUpperCase() + (parts[1]![0] ?? "").toUpperCase();
  }
  return (src[0] ?? "?").toUpperCase();
}

export function ContactAvatar({
  email,
  name,
  tier,
  size = 40,
  interactive = true,
}: {
  email: string;
  name: string | null;
  tier?: "important" | "normal" | "unimportant" | "unknown";
  size?: number;
  interactive?: boolean;
}) {
  const { mode } = useColorMode();
  const { openCompose } = useCompose();
  const initials = initialsOf(name, email);
  const bg = colorFor(email);
  const star = tier === "important";

  const inner = (
    <div
      style={{
        position: "relative",
        width: size,
        height: size,
        borderRadius: "50%",
        background: bg,
        color: "white",
        display: "grid",
        placeItems: "center",
        fontWeight: 600,
        fontSize: Math.round(size * 0.38),
        flexShrink: 0,
        boxShadow: star
          ? `0 0 0 2px ${palette[mode].bgSurface}, 0 0 0 4px ${palette[mode].accent}`
          : undefined,
      }}
    >
      {initials}
      {star ? (
        <span
          aria-label="重要联系人"
          style={{
            position: "absolute",
            right: -2,
            bottom: -2,
            background: palette[mode].accent,
            color: "white",
            width: Math.max(14, Math.round(size * 0.35)),
            height: Math.max(14, Math.round(size * 0.35)),
            borderRadius: "50%",
            display: "grid",
            placeItems: "center",
            fontSize: Math.max(10, Math.round(size * 0.22)),
            border: `2px solid ${palette[mode].bgSurface}`,
            boxSizing: "content-box",
          }}
        >
          ★
        </span>
      ) : null}
    </div>
  );

  if (!interactive) {
    return <Tooltip title={name ? `${name} <${email}>` : email}>{inner}</Tooltip>;
  }

  const tip = `${name ? `${name} ` : ""}<${email}> — 点击给 TA 写邮件`;
  return (
    <Tooltip title={tip}>
      <button
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          openCompose({ to: [email] });
        }}
        aria-label={`给 ${name ?? email} 写邮件`}
        style={{
          border: "none",
          background: "transparent",
          padding: 0,
          cursor: "pointer",
          display: "inline-flex",
          borderRadius: "50%",
        }}
      >
        {inner}
      </button>
    </Tooltip>
  );
}
